import Button from "@components/Button";
import { Button as MantinButton, Modal } from "@mantine/core";
import { RiAlertFill } from "react-icons/ri";

export default function DeleteDialog({
  doDelete,
  doClose,
  open,
  title,
  body,
  hideSubTitle,
  subTitle,
  deleteLoading,
  confirmDeleteTitle,
}) {
  const handleClose = () => {
    doClose();
  };

  const handleDialogDelete = () => {
    doDelete();
  };

  return (
    <Modal
      opened={open}
      onClose={handleClose}
      centered
      size="md"
      withCloseButton={false}
      overlayProps={{
        blur: 3,
      }}
    >
      <div className="flex flex-col justify-center items-center gap-2 py-3">
        <RiAlertFill className="text-5xl text-red-500 bg-red-500/20 p-2 rounded-full" />
        <div className="font-semibold text-lg">{title ?? "Are you sure?"}</div>
        {!hideSubTitle && (
          <div className="mb-4 text-gray-500 text-sm text-center">
            {subTitle ?? "You cannot undo this action later."}
          </div>
        )}
        <div className="flex items-center flex-col-reverse gap-2">
          <Button
            ariaLabel="cancel"
            id="delete-cancel-dialog"
            onClick={() => doClose()}
            fullWidth
            styles={{
              root: {
                backgroundColor: "#fff",
                border: "1px solid #d4d4d8",
                color: "black",
              },
            }}
          >
            Cancel
          </Button>
          <MantinButton
            color="white"
            bg="red"
            onClick={handleDialogDelete}
            aria-label="confirm delete"
            fullWidth
            loading={deleteLoading}
          >
            {confirmDeleteTitle ?? "Yes, Delete it"}
          </MantinButton>
        </div>
      </div>
    </Modal>
  );
}
